import React from "react";

function formatNumber(value: string) {
  let newValue = value.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
  newValue = newValue.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
  newValue = newValue
    .replace(".", "$#$")
    .replace(/\./g, "")
    .replace("$#$", ".");
  newValue = newValue.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数
  return newValue;
}

function formatRoundNumber(value: string) {
  return value.replace(/[^\d]/g, "");
}
export { formatNumber, formatRoundNumber };
